var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIXco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 71.5",
    style: {
      enableBackground: "new 0 0 150 71.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,39.1l-12.9,13l-0.6,0.6L44.5,70.1c-1.8,1.8-4.9,1.8-6.7,0l-9.6-9.6c-1.9-1.8-1.9-4.9,0-6.7l17.4-17.4 l0.6-0.6l-0.1,0l-18-18c-1.9-1.9-1.9-4.9,0-6.7l9.6-9.6c1.8-1.8,4.9-1.8,6.7,0L55,11.9l0,0l10.7,10.7l10,10 C77.4,34.5,77.3,37.3,75.5,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,31.2l13.5-13.5c1.8-1.8,1.8-4.9,0-6.7l-9.6-9.6c-1.8-1.8-4.9-1.8-6.7,0L67.1,14.9L83.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,40.3L67.1,56.6l13.5,13.5c1.8,1.8,4.9,1.8,6.7,0l9.6-9.6c1.8-1.8,1.8-4.9,0-6.7L83.4,40.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,20.7v46.6c0,2.3,1.9,4.3,4.3,4.3h11.3c2.4,0,4.3-1.9,4.3-4.3V40.5L0,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,31.3V6.5c0-2.3-1.9-4.3-4.3-4.3H4.3C1.9,2.2,0,4.2,0,6.5v5L19.8,31.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.9,70.1c-1.7-0.9-3-2.1-4-3.7c-1-1.6-1.4-3.4-1.4-5.4c0-2,0.5-3.8,1.4-5.4c1-1.6,2.3-2.8,4-3.7 s3.6-1.3,5.7-1.3c1.9,0,3.7,0.3,5.2,1s2.8,1.7,3.8,3l-4.3,3.8c-1.2-1.6-2.7-2.3-4.4-2.3c-1.4,0-2.6,0.5-3.4,1.4s-1.3,2.1-1.3,3.7 s0.4,2.8,1.3,3.7s2,1.4,3.4,1.4c1.7,0,3.1-0.8,4.4-2.3l4.3,3.8c-1,1.3-2.3,2.3-3.8,3s-3.3,1-5.2,1C115.5,71.4,113.6,71,111.9,70.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,70.1c-1.7-0.9-3.1-2.2-4-3.7c-1-1.6-1.5-3.4-1.5-5.4s0.5-3.8,1.5-5.4s2.3-2.8,4-3.7 c1.7-0.9,3.7-1.3,5.8-1.3s4.1,0.5,5.8,1.3c1.7,0.9,3.1,2.2,4,3.7c1,1.6,1.5,3.4,1.5,5.4s-0.5,3.8-1.5,5.4c-1,1.6-2.3,2.8-4,3.7 c-1.7,0.9-3.7,1.3-5.8,1.3C136.5,71.4,134.6,71,132.9,70.1z M140.9,65.3c0.7-0.4,1.2-1,1.6-1.8c0.4-0.8,0.6-1.6,0.6-2.7 c0-1-0.2-1.9-0.6-2.7c-0.4-0.8-0.9-1.3-1.6-1.8s-1.4-0.6-2.3-0.6s-1.6,0.2-2.3,0.6s-1.2,1-1.6,1.8s-0.6,1.6-0.6,2.7 c0,1,0.2,1.9,0.6,2.7c0.4,0.8,0.9,1.3,1.6,1.8s1.4,0.6,2.3,0.6C139.5,65.9,140.3,65.7,140.9,65.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,69.9v-2.8c0-0.9-0.7-1.6-1.6-1.6H100c-0.9,0-1.6,0.7-1.6,1.6v2.8v-2.1v2.1c0,0.9,0.7,1.6,1.6,1.6h2.8 C103.6,71.5,104.3,70.8,104.3,69.9v-2.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIXco);
export default __webpack_public_path__ + "static/media/iXco.04f6fda9739a94b3420e3b4982f42ff2.svg";
export { ForwardRef as ReactComponent };